export const EVENT_PREVIEW_DATE_FORMAT = 'DD MMMM / HH:mm';
export const EMAIL_PATTERN =
    /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/;
export const ACCEPTED_FILE_FORMATS = '.doc, .docx, .ppt, .pptx, .pdf';
export const TEN_MB_IN_BYTES = 10485760;
